import { Service } from "@roc/feature-app-core";

const url = {
  GET_APPRAISAL_REASSIGNMENT_LETTER_DATA: '/api/v1/loan/appraisalReassignmentLetter/getAppraisalReassignmentLetterData',
  SIGN: '/api/v1/loan/appraisalReassignmentLetter/sign',
  DOWNLOAD_APPRAISAL_LETTER: '/api/v1/loan/appraisalReassignmentLetter/downloadAppraisalLetter',
};

export class AppraisalReassignmentLetterService extends Service{
  url;

  constructor() {
    super();
    this.url = url;
  }

  getAppraisalLetterInformation(loanId, propertyId){
    return this.get(`${this.url.GET_APPRAISAL_REASSIGNMENT_LETTER_DATA}?loanId=${loanId}&propertyId=${propertyId}`);
  }

  sign(body: FormData) {
    return this.post(url.SIGN, body, {'content-type': 'multipart/form-data'});
  }

  downloadAppraisalLetter(loanId: number, propertyId: number) {
    return this.get(url.DOWNLOAD_APPRAISAL_LETTER, {loanId, propertyId},{responseType: 'arraybuffer'}).then(response => new Blob([response.data]));
  }
}